/**
 * Every route path in one place. Components link via `paths.*` rather than
 * string literals, so a URL change cannot leave a dead link behind.
 *
 * URLs are grouped by business domain — `/budgeting/…` and `/accounting/…` —
 * matching the API's route groups and the two Supabase projects behind them.
 */
export const paths = {
  login: '/login',
  forgotPassword: '/forgot-password',

  budgeting: {
    root: '/budgeting',
    dashboard: '/budgeting/dashboard',
    users: '/budgeting/users',
    plans: '/budgeting/plans',
    engagement: '/budgeting/engagement',
  },

  accounting: {
    root: '/accounting',
    dashboard: '/accounting/dashboard',
    chartOfAccounts: '/accounting/chart-of-accounts',
    journals: '/accounting/journals',
    reports: '/accounting/reports',
  },
} as const;

/**
 * Where an admin lands after signing in, and where `/` redirects to. Budgeting
 * is the default section.
 */
export const DEFAULT_PATH = paths.budgeting.dashboard;
